export function ErrorPage() {
  return <>エラーが発生しました。</>;
}
